import { useQuery } from "@tanstack/react-query";
import { checkAlpacaAccountStatus } from "../service";

export const QUERY_KEY = "alpaca-account-status";
export const useCheckAlpacaAccountStatus = () => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => checkAlpacaAccountStatus(),
  });
};
